import React from 'react';
import { cn } from '../../lib/cn';

interface LedgerFieldProps {
  label: string;
  htmlFor?: string;
  error?: string;
  hint?: string;
  className?: string;
  children: React.ReactNode;
}

export const LedgerField: React.FC<LedgerFieldProps> = ({ label, htmlFor, error, hint, className, children }) => (
  <div className={cn('mb-3', className)}>
    <label htmlFor={htmlFor} className="cap-label block">
      {label}
    </label>
    <div className="mt-1">{children}</div>
    {/* Reserved line so a validation message never shifts the layout. */}
    <p className={cn('mt-0.5 min-h-4 text-scale-0', error ? 'text-sev-critical' : 'text-ink-muted')}>
      {error ?? hint ?? ''}
    </p>
  </div>
);
